/**
 * massmailer uses code from write-std-dok.js too.
 * loads a list of appointments events
 */
if (window.location.pathname === '/sub_massenmailer.php') {
    $(document).on('loadFinish', function () {

        var appointmentListAlreadyCalled = false;
        var useEventCheckBox = $('#selectAppointmentFormSendAppointment');
        if (useEventCheckBox.prop('checked')) {
            // on load is already checked
            massMailerHandling(useEventCheckBox);
        } else {
            // on load is unchecked, watch for check
            useEventCheckBox.on('ifChecked', function () {
                if (useEventCheckBox.val() !== '' &&
                    useEventCheckBox.val() !== '0' &&
                    appointmentListAlreadyCalled === false
                ) {
                    appointmentListAlreadyCalled = true;
                    loadListOfSelectedAppointments(useEventCheckBox);
                }
            });
        }
    });

    /**
     *
     * @param useEventCheckBox
     */
    function massMailerHandling(useEventCheckBox) {
        $('#collapseAppointment').show();
        if (useEventCheckBox.val() !== '0') {
            loadListOfSelectedAppointments(useEventCheckBox);
        }
    }

    /**
     * is checkbox set, load all appointments which are selected (selectAppointmentFormSelectedAppointments)
     * #selectAppointmentFormSelectedAppointments will be filled by write-std-dok.js
     * @param useEventCheckBox
     */
    function loadListOfSelectedAppointments(useEventCheckBox) {
        if (useEventCheckBox.val() !== '0') {
            $.ajax({
                dataType: 'json',
                data: {ids: $('#selectAppointmentFormSelectedAppointments').val()},
                url: $('#selectAppointmentFormSelectAppointments').data('urlLoadSelectedAppointments'),
                loadingOverlay: true
            }).done(function (data) {
                $('.selectedAppointmentsContainer').html(data.content);
            });
        }
    }
}
